import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";

import TicketStatuses from "../../components/ticketStatuses";

const TicketsFilter = props => {
  const [doctorId, setDoctorId] = useState(null);
  const [responsible, setResponsible] = useState(null);
  const [status, setStatus] = useState(null);

  function applyFilter(responsible, status, doctorId) {
    let obj = {
      responsible, status, doctorId
    };

    for (const [key, value] of Object.entries(obj)) {
      if (!value) {
        delete obj[key];
      }
    }

    props.setFilters(obj);
  }

  return (
    <Fragment>
      <div className="d-flex flex-row align-items-end">
        <TextField
          className="mr-3"
          select
          SelectProps={{
            native: true
          }}
          onChange={e => {
            applyFilter(e.target.value, status, doctorId);
            setResponsible(e.target.value);
          }}
        >
          <option value="">Select Currently Responsible</option>
          {props.staffList.map(staff => (
            <option key={staff.id} value={staff.id}>
              {staff.name}
            </option>
          ))}
          <option value="">All</option>
        </TextField>
        <TextField
          className="mr-3"
          select
          SelectProps={{
            native: true
          }}
          onChange={e => {
            applyFilter(responsible, e.target.value, doctorId);
            setStatus(e.target.value);
          }}
        >
          <option value="">Select Ticket Status</option>
          <TicketStatuses exclude={["DOCTOR_ACTION_REQUIRED"]} />
          <option value="ALL">All</option>
        </TextField>
        <TextField
          select
          SelectProps={{
            native: true
          }}
          onChange={e => {
            applyFilter(responsible, status, e.target.value);
            setDoctorId(e.target.value);
          }}
        >
          <option value="">Select Doctor</option>
          {props.doctorList.map(doctor => (
            <option key={doctor._id} value={doctor._id}>
              {doctor.firstName} {" "} {doctor.lastName}
            </option>
          ))}
        </TextField>
      </div>
    </Fragment>
  );
};

export default TicketsFilter;

TicketsFilter.prototype = {
  setFilters: PropTypes.func
};
